export enum TrainingReportSubject {
  Employee,
  Site
}
